import React from 'react';
import '../What.css';

export default () => {
  return (
    <article className="page-content what-content">
      <section className="what-content-services">
        <div className="what-content-service">
          <h3>Pre-Listing Coordination</h3>
          <ul>
            <li>Write listing agreement (with your specified terms) and send to seller for signatures</li>
            <li>Send an introductory email to the client, attaching a copy of the listing agreement and copies of all necessary disclosures (property disclosure, dual entry form, community association disclosure, lead based paint, etc.) for completion</li>
            <li>Coordinate photographer’s access to the property with the seller/occupant</li>
            <li>Once photos are completed, organize/rename (in order of how they’ll appear on MLS) and save in your Drive/Dropbox file</li>
            <li>Coordinate/notify seller of sign and lockbox delivery</li>
            <li>Once disclosures are completed, save in your Drive/Dropbox file</li>
          </ul>
        </div>
        <div className="what-content-service">
          <h3>Listing Entry</h3>
          <ul>
            <li>Review all paperwork and notify agent of any missing items</li>
            <li>Enter listing into FMLS, GAMLS (and KWLS for Keller Williams agents) - Upload all photos and disclosures into MLS systems</li>
            <li>Include captions (if provided) onto each photo in FMLS</li>
            <li>Submit all listing docs/disclosures to your office system</li>
          </ul>
        </div>
        <div className="what-content-service">
          <h3>Post-Listing Management</h3>
          <ul>
            <li>Set up in Showingtime notifications/appoint preferences & feedback requests</li>
            <li>Assign lockbox in Supra</li>
            <li>Set up in VoicePad system (if applicable)</li>
            <li>Create a one page flyer (PDF version for print and jpeg for email/social media)</li>
            <li>Send “just listed” email to the seller with live listing info with copy of flyer & FMLS buyer report - Order seller coverage home warranty (if needed)</li>
            <li>Claim listing on Zillow & Trulia</li>
            <li>Blast new listing, caravan and/or open house to your office</li>
            <li>Create “just listed” postcards (if needed)</li>
            <li>Schedule agent caravans and open houses as needed (with 3 days notice)</li>
            <li>Create version of flyer advertising open houses (print & digital versions)</li>
            <li>Update price as needed in MLS, update price (if needed) on flyer</li>
          </ul>
        </div>
      </section>
      <section className="what-content-rates">
        <h3>Rates</h3>
        <table className="rates-table">
          <thead>
            <tr>
              <td></td>
              <th>Package 1</th>
              <th>Package 2</th>
              <th>Package 3</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Pre-listing Coordination</th>
              <td><span className="check">&#10003;</span></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <th>Post-listing Coordination</th>
              <td><span className="check">&#10003;</span></td>
              <td><span className="check">&#10003;</span></td>
              <td></td>
            </tr>
            <tr>
              <th>Listing Entry</th>
              <td><span className="check">&#10003;</span></td>
              <td><span className="check">&#10003;</span></td>
              <td><span className="check">&#10003;</span></td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th></th>
              <td>$400</td>
              <td>$300</td>
              <td>$75</td>
            </tr>
          </tfoot>
        </table>
      </section>
      <section>
        <h3>What's Not Included?</h3>
        <p>
          Our services are meant to minimize your involvement in the day to day busywork of listing management, but there are some things you must remain responsible for:
        </p>
        <ul>
          <li>Verifying and ensuring that all property info provided (by agent and seller) is accurate, to the best of your knowledge.</li>
          <li>Negotiating all terms of the listing agreement and any subsequent offers.</li>
          <li>Providing verbiage for MLS comments and photo captions, and any verbiage for marketing items (flyers, postcards, e-Blasts, etc.)</li>
          <li>Any visits to the property - granting access to photographers, delivery of signs, lockboxes, directionals, etc.</li>
        </ul>
      </section>
    </article>
  );
};



// WEBPACK FOOTER //
// ./src/what/ListingCoordination.js